if (customElements.get('fostr-deferred-media') === undefined) {
  class FostrDeferredMedia extends HTMLElement {
    constructor () {
      super()

      this.poster = this.querySelector('[id^="Deferred-Poster-"]')
      if (!this.poster) {
        return
      };
    }

    connectedCallback () {
      this.poster.addEventListener('click', this.loadContent.bind(this))

      if (this.dataset.autoplay) {
        this.autoplay()
      }
    }

    async loadContent () {
      await window.pauseAllMedia()

      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div')
        content.classList.add('video-wrapper')
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

        this.setAttribute('loaded', true)
        this.querySelector('button').style.display = 'none'

        if (this.dataset.type === 'youtube') {
          this.appendChild(content).focus()
        } else {
          this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()
        }
      }
    }

    autoplay () {
      const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          const video = entry.target
          if (entry.isIntersecting) {
            this.loadContent()
            lazyVideoObserver.unobserve(video)
          }
        })
      })

      lazyVideoObserver.observe(this)
    }
  }

  customElements.define('fostr-deferred-media', FostrDeferredMedia)
}

if (customElements.get('lazy-video') === undefined) {
  class LazyVideo extends HTMLElement {
    connectedCallback () {
      this.lazyLoad()
    }

    lazyLoad () {
      const lazyVideo = this.querySelector('[data-lazy-video]')

      if (!lazyVideo) return

      const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          const videoEl = entry.target

          if (entry.isIntersecting && videoEl.dataset.lazyVideo) {
            const videoSource = videoEl.querySelector('source')
            const screenSize = window.innerWidth < 990 ? 'mobile' : 'desktop'
            const videoWrapper = this.querySelector('[data-lazy-video-el="videoWrapper"]')
            let videoSize = ''

            if (videoWrapper.classList.contains('large-up-hide')) {
              videoSize = 'mobile'
            } else if (videoWrapper.classList.contains('small-hide') || videoWrapper.classList.contains('medium-hide')) {
              videoSize = 'desktop'
            } else {
              videoSize = 'all'
            }

            if (videoSize === 'all' || (videoSize === screenSize)) {
              videoSource.src = videoSource.dataset.src
              videoEl.load()
              videoEl.play()
              lazyVideoObserver.unobserve(videoEl)
            }
          }
        })
      })

      lazyVideoObserver.observe(lazyVideo)
    }
  }

  customElements.define('lazy-video', LazyVideo)
}
